import axios from "axios";
import { getCookie } from "../utils/getCookies";
import { rutas } from "../rutas/rutas";

/**
 * ✅ Backward compatible.
 * - method: 'get' | 'post' ...
 * - body: payload
 * - url: true => ver/procesar, false => completar (como lo tienes)
 * - action: 'ver' | 'procesar' | 'completar' | 'reparar' (opcional)
 */
export const molinoServices = async (
  method = "get",
  body,
  url = true,
  action = null
) => {
  const token2 = getCookie("token");

  // ✅ selector de endpoint (sin romper lo viejo)
  const endpoint = (() => {
    if (action === "reparar") return rutas.repararMolino;
    if (action === "completar") return rutas.completarMolino;
    if (action === "procesar") return rutas.procesarMolino;
    if (action === "ver") return rutas.verMolino;

    // comportamiento original
    if (url) return method === "get" ? rutas.verMolino : rutas.procesarMolino;
    return rutas.completarMolino;
  })();

  return axios({
    url: endpoint,
    method,
    headers: {
      token: token2,
    },
    data: body,
  });
};

/**
 * ✅ NUEVO:
 * Servicio para obtener los ratios del molino desde backend.
 * No rompe el molinoServices actual.
 *
 * Requiere que tengas en rutas:
 * - rutas.ratiosMolino
 *
 * Si no existe rutas.ratiosMolino, usa:
 * - rutas.verMolino + "/ratios"
 */
export const molinoRatiosServices = async () => {
  const token2 = getCookie("token");

  // ✅ Primero intenta la ruta nueva de ratios.
  // Si esa ruta no existe o falla, usa la ruta vieja /api/verMolino/,
  // porque tu backend también puede devolver ratios y ofertas ahí.
  try {
    return await axios({
      url: rutas.ratiosMolino,
      method: "get",
      headers: {
        token: token2,
      },
    });
  } catch (error) {
    console.warn("[MOLINO] rutas.ratiosMolino falló. Usando rutas.verMolino como respaldo.", error);

    return axios({
      url: rutas.verMolino,
      method: "get",
      headers: {
        token: token2,
      },
    });
  }
};